import './style.scss';
import Gravity from 'Gravity';

class CustomAudioPlayer {
    constructor(element) {
        this.block = element;
        this.audio = element.querySelector(".gravity-block-custom-audio-player__audio");
        this.playButton = element.querySelector(".gravity-block-custom-audio-player__play-button");
        this.pauseButton = element.querySelector(".gravity-block-custom-audio-player__pause-button");
        this.timeElapsed = element.querySelector(".gravity-block-custom-audio-player__time");
        this.progress = element.querySelector(".gravity-block-custom-audio-player__progress-bar");
        this.maxValue = 100;
        this.minutesInHour = 60;
    }

    init() {
        this.addListeners();
    }

    formatTime(time) {
        let min = Math.floor((time / this.minutesInHour) % this.minutesInHour);
        let sec = Math.floor(time % this.minutesInHour);

        sec = sec.toString().padStart('2', '0');
        min = min.toString().padStart('2', '0');

        return `${min}:${sec}`;
    }

    updateTimeElapsed(currentTime) {
        this.progress.value = Math.floor(
            (this.audio.currentTime / this.audio.duration) * this.maxValue
        );
        this.timeElapsed.innerHTML = `<span>Listen</span><span>(${this.formatTime(currentTime)})</span>`;
    }

    handleProgressBarClick(clickPosition) {
        const clickPositionOnProgressBar = clickPosition.pageX - this.progress.getBoundingClientRect().left;
        const percent = clickPositionOnProgressBar / this.progress.offsetWidth;
        this.audio.currentTime = percent * this.audio.duration;
        this.progress.value = percent * this.maxValue;
    }

    handleProgressBarKeyControll(e) {
        switch (e.key) {
            case "ArrowLeft":
                this.audio.currentTime -= 5;
                this.progress.value -= 5;
                break;
            case "ArrowRight":
                this.audio.currentTime += 5;
                this.progress.value += 5;
                break;
            default:
                break;
        }
    }

    play() {
        this.audio.play();
        this.block.setAttribute('data-player', 'played');
    }

    pause() {
        this.audio.pause();
        this.block.setAttribute('data-player', 'paused');
    }

    addListeners() {
        this.playButton.addEventListener("click", () => this.play());

        this.pauseButton.addEventListener("click", () => this.pause());

        this.audio.addEventListener("timeupdate", () => this.updateTimeElapsed(this.audio.currentTime));

        this.progress.addEventListener('click', (clickPosition) => this.handleProgressBarClick(clickPosition));

        this.progress.addEventListener('keydown', (e) => this.handleProgressBarKeyControll(e));
    }
};

Gravity.ready(() => {
    document.querySelectorAll('.gravity-block-custom-audio-player').forEach(module => {
        new CustomAudioPlayer(module).init();
    });
});
